<template>
  <vx-card class="my-2">
    <form-wizard :subtitle="null" :title="null" @on-complete="formSubmitted" color="rgba(var(--vs-primary), 1)"
                 finishButtonText="Create" stepSize="sm" shape="square">

      <!-- tab 1 content -->
      <tab-content class="mb-5" title="ITS Products" :before-change="validateStep1">


        <div class="vx-row">
          <div class="vx-col w-full mt-5">

            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />

            <vs-table
              id="work-order-create-select-formulation-section"
              @selected="handleSelected"
              v-model="selected"
              :data="formulations"
              :sst="true"
              stripe noDataText="Type to search products"
              class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th>FORMULATION CODE</vs-th>
                <vs-th>NAME</vs-th>
                <vs-th>TYPE</vs-th>
                <vs-th>MAX POSSIBLE PRODUCTION QUANTITY (Kg)</vs-th>
                <vs-th>UNALLOCATED FG STOCK (Kg)</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].formulation_type">
                    {{data[indextr].formulation_type}}
                  </vs-td>

                  <vs-td :data="data[indextr].max_products_possible.name">
                      {{toFixed(data[indextr].max_products_possible)}}
                  </vs-td>

                  <vs-td :data="data[indextr].formulation_stock">
                    {{toFixed(data[indextr].formulation_stock)}}
                  </vs-td>

                  <vs-td>
                    <vx-tooltip class="ml-2" text="RM stock/Formulation stock" position="left">
                      <vs-button @click.stop="onCLickViewRmStock(data[indextr].id)"
                                 size="small" color="primary" type="filled" icon-pack="feather" icon="icon-box"></vs-button>
                    </vx-tooltip>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>
            <vx-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vx-pagination>
          </div>
        </div>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content class="mb-5" title="Item Quantity and Production Line" :before-change="validateStep2">

        <div class="vx-row md:mb-16 mt-8">
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex w-full" class="w-full">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h6 class="mb-2">ITS Product Code</h6>
                    <small class="text-primary font-bold">{{selected.formulation_code}}</small>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex w-full" class="w-full">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h6 class="mb-2">ITS Product Name</h6>
                    <small class="text-primary font-bold">{{selected.name}}</small> <br>
                    <small class="text-xs">({{selected.formulation_type}})</small>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex w-full" class="w-full">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h6 class="mb-2">Max Product Possible (Kg)</h6>
                    <small class="text-primary font-bold">{{toFixed(selected.max_products_possible)}}</small>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex w-full" class="w-full">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h6 class="mb-2">Unallocated FG Stock (Kg)</h6>
                    <small class="text-primary font-bold">{{toFixed(selected.formulation_stock)}}</small>
                  </span>
              </vs-col>
            </vs-row>
          </div>
        </div>

        <div class="vx-row md:mb-3 mt-8">
          <div class="vx-col w-full">
            <h5 class="mb-4" style="color: #626262">Select Production Line</h5>
            <vs-table :data="production_lines" @selected="handleSelectedProductionLine" v-model="selected_production_line">

              <template slot="thead">
                <vs-th width="20%" class="text-sm">PRODUCTION LINE CODE</vs-th>
                <vs-th width="20%" class="text-sm">NAME</vs-th>
                <vs-th class="text-sm">TYPE</vs-th>
                <vs-th class="text-sm">MAX CAPACITY (KG)</vs-th>
                <vs-th class="text-sm">MAX CAPACITY (L)</vs-th>
                <vs-th width="10%"></vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="text-sm" :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].production_line_code">
                    {{ data[indextr].production_line_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].production_line_name">
                    {{ data[indextr].production_line_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>

                  <vs-td :data="data[indextr].max_capacity_kg">
                    {{ toFixed(data[indextr].max_capacity_kg) }}
                  </vs-td>

                  <vs-td :data="data[indextr].max_capacity_ltr">
                    {{ toFixed(data[indextr].max_capacity_ltr) }}
                  </vs-td>

                  <vs-td >
                    <vs-chip style="border-radius: 0" color="success" v-if="data[indextr].id === selected_production_line.id">
                      selected
                    </vs-chip>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
          </div>
        </div>

        <div class="vx-row mt-8">
          <div class="vx-col w:md-1/3">
            <small class="label">Please select the amount in KG that you wish to make.</small>
            <vs-input v-on:input="handleSelectedProductionLine()" :max="remainingQuantityKilo" type="number" v-model="unallocated_quantity"  name="unallocated_quantity" class="w-full required mt-2" label=""/>
          </div>
        </div>

        <div class="vx-row mt-8 mb-8">
          <div class="vx-col w:md-1/3">
            <label>Do you want add surplus RM items?</label>
            <vs-switch v-model="is_rm_waste_used" class="mt-4"/>
          </div>
        </div>
        <div class="vx-row md:mb-8 mt-8" v-if="is_rm_waste_used">
          <div class="vx-col w-full">
            <h5 class="mb-4" style="color: #626262">Raw Material Waste Items</h5>
            <vs-table
              v-model="rm_waste_items"
              :onlyClickCheckbox="true"
              multiple
              @selected="handleRmWasteItems"
              :data="rm_waste_items_list"
              :hoverFlat="true"
              id="assign-formulation-stock-inventory-pop-up"
              stripe>

              <template slot="thead">
                <vs-th width=""  class="text-sm" sort-key="sundry_item_code">WORK ORDER</vs-th>
                <vs-th width=""  class="text-xs">QUANTITY (KG)</vs-th>
                <vs-th width=""  class="text-xs">RAW MATERIALS</vs-th>
                <vs-th width=""  class="text-xs">STATUS</vs-th>
                <vs-th width="" class="text-xs">SELECTED RM WASTE Quantity (Kg)</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td class="text-sm text-primary font-semibold" :data="data[indextr].work_order">
                    {{ data[indextr].work_order}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].quantity">
                    {{ Number(data[indextr].quantity).toFixed(4)}}
                  </vs-td>

                  <vs-td class="text-sm">
                      <span v-for="(rm , index) in data[indextr].raw_materials" :key="index">{{ rm.raw_material+' ,' }}</span>
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].status">
                    <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                      {{ data[indextr].status}}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vs-input v-on:input="onInputRawMaterialWasteItemQty(data[indextr])" v-if="data[indextr].status === 'Available'" v-model="data[indextr].selected_quantity" class="w-full required" />
                    </div>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
        <!-- reblend section -->
        <div class="vx-row mt-8 mb-8" v-if="Number(selected.formulation_stock) > 0">
            <div class="vx-col w:md-1/3">
              <label>Do you want re-blend with unallocated FG stock?</label>
              <vs-switch v-model="is_reblended" class="mt-4"/>
            </div>
        </div>
        <div class="vx-row md:mb-8 mt-8" v-if="Number(selected.no_formulation_stock_items) > 0 && is_reblended">
          <div class="vx-col w-full">
            <h5 class="mb-4" style="color: #626262">FG stock for reblending</h5>
            <vs-table
              v-model="re_blend_inventory"
              :onlyClickCheckbox="true"
              multiple
              @selected="handleReBlendStock"
              :data="selected.formulation_stock_items"
              :hoverFlat="true"
              id="assign-formulation-stock-inventory-pop-up"
              stripe>

              <template slot="thead">
                <vs-th width="20%"  class="text-sm" sort-key="sundry_item_code">BATCH CODE</vs-th>
                <vs-th width="10%"  class="text-xs">MANUFACTURE DATE</vs-th>
                <vs-th width="10%"  class="text-xs">EXP DATE</vs-th>
                <vs-th width="10%"  class="text-xs">MLOR %</vs-th>
                <vs-th width="10%" class="text-xs">BATCH QTY (KG)</vs-th>
                <vs-th width="10%" class="text-xs">COMPLETED/AVAILABLE QTY (KG)</vs-th>
                <vs-th width="20%" class="text-xs">STATUS</vs-th>
                <vs-th width="10%" class="text-xs">Quantity (Kg) to reblend</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td class="text-sm text-primary font-semibold" :data="data[indextr].work_order_code">
                    {{ data[indextr].work_order_code}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].manufacture_date">
                    {{ data[indextr].manufacture_date}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].expiration_date">
                    {{ data[indextr].expiration_date}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].mlor">
                    {{ data[indextr].mlor}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].total_quantity">
                    {{ toFixed(data[indextr].total_quantity)}}
                  </vs-td>


                  <vs-td class="text-sm" :data="data[indextr].completed_quantity">
                    {{ toFixed(data[indextr].completed_quantity)}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].status">
                    <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                      {{ data[indextr].status}}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vs-input v-on:input="onInputReBlendInventory(indextr)" v-if="data[indextr].status === 'In_Stock'" v-model="data[indextr].quantity" class="w-full required" />
                    </div>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <div class="flex flex-wrap items-center justify-end mt-8">
          <h6 class="break-all">Remaining Production Line Capacity (Kg) : {{max_kilo_capacity}}</h6>
        </div>
        <div class="flex flex-wrap items-center justify-end mt-8">
          <h5 class="break-all">Total quantity to manufacture (Ltr) : {{totalQuantityToManufactureLtr}}</h5>
        </div>
        <div class="flex flex-wrap items-center justify-end mt-8">
          <h5 class="break-all">Total quantity to manufacture (Kg) : {{totalQuantityToManufacture}}</h5>
        </div>


      </tab-content>

      <!-- tab 3 content -->
      <tab-content class="mb-5" title="Summary">
        <div class="vx-row" id="work-order-create-section">
          <div class="vx-col md:w-1/3 w-full">
            <h5 class="mb-2" style="color: #626262">Finished Product</h5>
            <div class="vx-row mt-0">
              <div class="vx-col lg:w-full w-full">
                <vs-table noDataText="">
                  <template>
                    <vs-tr>
                      <vs-td class="">ITS Product Code</vs-td>
                      <vs-td class="font-bold text-primary">{{selected.formulation_code}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">ITS Product Name</vs-td>
                      <vs-td class="font-bold text-primary">{{selected.name}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Type</vs-td>
                      <vs-td class="font-bold text-primary">{{selected.formulation_type}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Max Product Possible (Kg)</vs-td>
                      <vs-td class="font-bold text-primary">{{toFixed(selected.max_products_possible)}}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <h5 class="mb-2" style="color: #626262">Production Line</h5>
            <div class="vx-row mt-0">
              <div class="vx-col lg:w-full w-full">
                <vs-table noDataText="">
                  <template>
                    <vs-tr>
                      <vs-td class="">Production Line Code</vs-td>
                      <vs-td class="font-bold text-primary">{{selected_production_line.production_line_code}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Production Line Name</vs-td>
                      <vs-td class="font-bold text-primary">{{selected_production_line.production_line_name}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Type</vs-td>
                      <vs-td class="font-bold text-primary">{{selected_production_line.type}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Max Capacity Kg</vs-td>
                      <vs-td class="font-bold text-primary">{{toFixed(selected_production_line.max_capacity_kg)}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="">Max Capacity L</vs-td>
                      <vs-td class="font-bold text-primary">{{toFixed(selected_production_line.max_capacity_ltr)}}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full">

            <h5 v-if="is_rm_waste_used" class="mb-2 mt-8" style="color: #626262">RM waste used items</h5>
            <vs-table
              v-if="is_rm_waste_used"
              :data="rm_waste_items"
              class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" class="text-xs">WORK ORDER</vs-th>
                <vs-th width="10%" class="text-xs">QUANTITY (KG)</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].work_order">
                    {{ data[indextr].work_order}}
                  </vs-td>
                  <vs-td :data="data[indextr].selected_quantity">
                    {{ toFixed(data[indextr].selected_quantity) }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <h5 v-if="is_reblended && re_blend_inventory.length > 0" class="mb-2 mt-8" style="color: #626262">Re-Blend from FG stock</h5>
            <vs-table
              v-if="is_reblended && re_blend_inventory.length > 0"
              :data="re_blend_inventory"
              class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" class="text-xs">BATCH CODE</vs-th>
                <vs-th width="10%" class="text-xs">QUANTITY (KG)</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].work_order_code">
                    {{ data[indextr].work_order_code}}
                  </vs-td>
                  <vs-td :data="data[indextr].quantity">
                    {{ toFixed(data[indextr].quantity) }}
                  </vs-td>
                </vs-tr>
                <vs-tr class="font-semibold">
                  <vs-td>Total</vs-td>
                  <vs-td>{{toFixed(totalReBlendQuantity)}}</vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <div class="flex flex-wrap items-center justify-end mt-8">
              <h6>Made for stock (Kg) : {{Number(unallocated_quantity).toFixed(2)}}</h6>
            </div>
            <div class="flex flex-wrap items-center justify-end mt-8">
              <h5>Total Manufacturing Qty (Kg) : {{totalQuantityToManufacture}}</h5>
            </div>
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col w-full">
            <small class="label">Note</small>
            <vs-textarea class="mb-0" v-model="note" height="150px" />
          </div>
        </div>
      </tab-content>

    </form-wizard>
    <work-order-view-rm-stock-pop-up ref="workOrderViewRmStockPopUp"/>

  </vx-card>
</template>

<script>
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import WorkOrderViewRmStockPopUp from "@/components/popups/manufacturing/work-order/WorkOrderViewRmStockPopUp";

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  const InventoryRepository = RepositoryFactory.get('inventory');
  const FormulationsRepository = RepositoryFactory.get('formulations');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import { perPageList} from "@/constants/config";

  export default {
    name: "WorkOrderViewFormulationSection",
    data() {
      return {
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: 10,
        descriptionItems: perPageList,
        formulations: [],
        order_formulations_list: [],
        selected: {},
        order_formulations_items: [],
        production_lines: [],
        selected_production_line: {},
        previous_selected_production_line: {},
        is_exceed: false,
        selected_item_quantity_total: 0,
        total_item_quantity_total: 0,
        note: '',
        unallocated_quantity: 0,
        is_add_unallocated_quantity: false,
        max_kilo_capacity: 0,
        remainingQuantityKilo: 0,
        is_rm_waste_used: false,
        rm_waste_items: [],
        rm_waste_items_list: [],
        is_reblended: false,
        re_blend_inventory: []
      }
    },
    mixins: [SuccessMessage, ErrorMessages, Filter],
    components: {
      FormWizard,
      TabContent,
      WorkOrderViewRmStockPopUp,
    },
    async mounted() {
      // await this.loadFormulations();
      // await this.fetchOrderFormulations();
    },
    methods: {
      onCLickViewRmStock(id) {
        this.$refs.workOrderViewRmStockPopUp.openPopup(id)
      },
      async formSubmitted() {
        await this.$vs.loading({
          container: '#work-order-create-section',
          scale: 0.45
        });
        try {

          this.total_item_quantity_total = this.order_formulations_items.reduce(function (acc, val) {
            return acc + Number(val.pending_manufacture_quantity);
          }, 0);

          const payload = {
            production_line_id: this.selected_production_line.id,
            formulation_id: this.selected.id,
            formulation_order_item_ids: [],
            unallocated_quantity: this.unallocated_quantity,
            note: this.note,
            is_reblended: this.is_reblended,
            is_rm_waste_used: this.is_rm_waste_used,
            rm_waste_items: this.is_rm_waste_used ? this.rm_waste_items.map((n) => { return { work_order_id: n.work_order_id,  quantity: n.selected_quantity} }) : [],
          };
          if(this.re_blend_inventory.length > 0) {
            payload.reblended_stock = this.re_blend_inventory.map((n) => {
              return {formulation_stock_inventory_id: n.id, quantity: n.quantity.toString()}
            })
          }
          // unallocated_quantity: Number(this.selected_production_line.max_capacity_kg) -  this.selected_item_quantity_total,
          await ManufacturingRepository.createWorkOrder(payload);
          this.showSuccessMessage('Work order create successfully');
          this.$router.push({path: `/pages/manufacturing/work-orders`})
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#work-order-create-section > .con-vs-loading')

      },
      async handleSelected() {
        const vue = this
        await this.$vs.loading({
          container: '#work-order-create-select-formulation-section',
          scale: 0.45
        });

        await this.getProductionLiveLines()
        await this.getRawMaterialWasteItems()

        const formatted_production_lines = this.production_lines.map((n) => {
            n.max_capacity_kg = Number(n.max_capacity_kg)
            n.max_capacity_ltr = Number(n.max_capacity_ltr)
            return n
        })

          this.selected_production_line = formatted_production_lines[0]
          this.previous_selected_production_line = formatted_production_lines[0]

        this.$vs.loading.close('#work-order-create-select-formulation-section > .con-vs-loading')
      },
      handleSelectedProductionLine() {
        const vue = this
        const production_line_total_quantity = Number(this.selected_production_line.max_capacity_kg);
        const production_line_ltr_total_quantity = Number(this.selected_production_line.max_capacity_ltr);
        const total_selected_item_quantity = this.totalQuantityToManufacture
        this.selected_item_quantity_total = total_selected_item_quantity
        const lt_max_capacity = this.selected_item_quantity_total * Number(this.selected.formulation_per_lt)
        if (total_selected_item_quantity > production_line_total_quantity || lt_max_capacity > production_line_ltr_total_quantity) {
          this.unAllocatedQuantityChanger()
          this.$vs.dialog({
            color: 'danger',
            title: `Warning`,
            text: 'The total quantity of selected items exceeds the maximum capacity of the product line',
            acceptText: 'Confirm'
          })
        } else {

        }
      },
      unAllocatedQuantityChanger() {
        const ltr_kilo_capacity = (Number(this.selected_production_line.max_capacity_kg) / Number(this.selected.formulation_per_lt)).toFixed(3)
        const kilo_capacity = Number(this.selected_production_line.max_capacity_kg).toFixed(3)
        if(ltr_kilo_capacity < kilo_capacity) {
          this.max_kilo_capacity = ltr_kilo_capacity
        } else {
          this.max_kilo_capacity = kilo_capacity
        }
        if (Number(this.unallocated_quantity) > Number(this.max_kilo_capacity)) {
          this.unallocated_quantity = Number(this.max_kilo_capacity).toFixed(3)
        }
        if(Number(this.unallocated_quantity) < 0) {
          this.unallocated_quantity = 0
        }
      },
      async getRawMaterialWasteItems() {
        const { data } = (await InventoryRepository.getRawMaterialWasteItemListByFormulationId(this.selected.id)).data
        this.rm_waste_items_list = data.map((n) => {
          n.selected_quantity = 0
          return n
        })
      },
      handleRmWasteItems() {

      },
      onInputRawMaterialWasteItemQty(data) {
        this.rm_waste_items = []
        this.rm_waste_items_list.forEach((m) => {
          if(Number(m.selected_quantity) > 0) {
            if(Number(m.selected_quantity) > Number(m.quantity)) {
              m.selected_quantity = m.quantity
            }
            this.rm_waste_items.push(m)
          }
        })
      },
      async getProductionLiveLines() {
        const {data} = await ManufacturingRepository.getLiveProductionLineList(1, 50);
        this.production_lines = data.data.filter((n) => {
          const type = this.selected.formulation_type === 'powder' || this.selected.formulation_type === 'spray dry powder' ? 'powder' :  this.selected.formulation_type
          return n.type === type
        })
      },
      // async fetchOrderFormulations() {
      //   await this.$vs.loading({
      //     container: '#work-order-create-select-formulation-section',
      //     scale: 0.45
      //   });
      //   try {
      //     const {data} = await ManufacturingRepository.getFormulationsOrderList();
      //     this.order_formulations_list = data.data
      //   } catch (e) {
      //   }
      //   this.$vs.loading.close('#work-order-create-select-formulation-section > .con-vs-loading')
      // },
      toFixed(number) {
        return Number(number).toFixed(2)
      },
      validateStep1() {
        return new Promise((resolve, reject) => {
          if (!this.selected.id) {
            this.$vs.dialog({
              color: 'danger',
              title: `Warning`,
              text: `Please select a product!`,
              acceptText: 'Close'
            })
            reject("correct all values");
          } else if(!this.selected.formulation_type){
            this.$vs.dialog({
              color: 'danger',
              title: `Warning`,
              text: `Error in record. Formulation type missing!`,
              acceptText: 'Close'
            })
            reject("correct all values");
          } else {
            this.unallocated_quantity = 0
            resolve(true)
          }
        })
      },
      validateStep2() {
        return new Promise((resolve, reject) => {
          if (Number(this.totalQuantityToManufacture) > Number(this.selected.max_products_possible)) {
            this.$vs.dialog({
              color: 'danger',
              title: `Warning`,
              text: `The total quantity of selected items (${this.totalQuantityToManufacture} Kg) exceeds the max product possible quantity (${this.selected.max_products_possible} Kg)!`,
              acceptText: 'Close'
            })
          } else if(Number(this.totalQuantityToManufacture) === 0) {
            this.$vs.dialog({
              color: 'danger',
              title: `Warning`,
              text: `The total quantity of manufacturing is 0!`,
              acceptText: 'Close'
            })
            reject("correct all values");
          } else {
            resolve(true)
          }
        })
      },
      async loadFormulations() {
        this.$vs.loading()
        const {data} = await ManufacturingRepository.getFormulationsOrderListForStock(this.filterQuery, this.page, this.perPage)
        this.formulations =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },
      filterQueryUpdate (){
        if(!!this.filters.search) {
          this.loadFormulations()
        } else {
          this.formulations = []
        }
      },

      handleChangePage(page) {
        this.page=page;
        this.loadFormulations()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadFormulations()
        }

      },
      changePage(index) {
        this.page = 1
        this.perPage = this.descriptionItems[index]
      },

      checkFgStockAvailable(qty, fg_stock) {
        return Number(qty) <= Number(fg_stock)
      },
      checkFgStockAllocationColumn() {
        return Number(this.totalPendingManufacturingQuantityKilo) <= Number(this.selected.formulation_stock)
      },
      handleReBlendStock() {
        this.onInputReBlendInventory(0)
      },
      onInputReBlendInventory(index) {
        let changing_stock = this.selected.formulation_stock_items[index]
        if(Number(this.selected.formulation_stock_items[index].quantity) > 0) {
          this.re_blend_inventory = this.re_blend_inventory.filter((x) => x.id !== changing_stock.id)
          this.re_blend_inventory.push(changing_stock)
        } else {
          this.re_blend_inventory = this.re_blend_inventory.filter((x) => x.id !== changing_stock.id)
        }
      },
    },
    computed: {
      totalPendingManufacturingQuantityKilo() {
        return Number(0).toFixed(2)
      },
      totalPendingManufacturingQuantityLiter() {
        return Number(0).toFixed(2)
      },
      totalSelectedQuantityKilo() {
        return Number(0).toFixed(2)
      },
      totalSelectedQuantityLiter() {
        return Number(0).toFixed(2)
      },
      remainingQuantityKilo() {
        const remaining = Number(this.selected_production_line.max_capacity_kg)
        return remaining.toFixed(2)
      },
      remainingQuantityLiter() {
        const remaining = Number(this.selected_production_line.max_capacity_ltr)
        return remaining.toFixed(2)
      },
      totalQuantityToManufacture() {
        return Number(this.unallocated_quantity).toFixed(2)
      },
      totalQuantityToManufactureLtr() {
        const total = Number(this.selected.formulation_per_lt) * Number(this.unallocated_quantity)
        return Number(total).toFixed(2)
      },
      isMaxProductPosibleKiloLessThanTotalOrderQuantity() {
        return Number(this.selected.total_order_quantity) >= Number(this.selected.max_products_possible)
      },
      remainingProductionLineCapacity() {
        const total = Number(this.selected_production_line.max_capacity_kg) -  Number(this.totalQuantityToManufacture)
        return Number(total).toFixed(2)
      },
      totalReBlendQuantity() {
        const total = this.re_blend_inventory.reduce(function (acc, val) {
          return acc + Number(val.quantity);
        }, 0);
        return total ? Number(total).toFixed(2) : 0
      },
    },
    watch: {
      // unallocated_quantity: function () {
      //   const ltr_kilo_capacity = (Number(this.selected_production_line.max_capacity_kg) / Number(this.selected.formulation_per_lt)).toFixed(3)
      //   const kilo_capacity = Number(this.selected_production_line.max_capacity_kg).toFixed(3)
      //   if(ltr_kilo_capacity < kilo_capacity) {
      //     this.max_kilo_capacity = ltr_kilo_capacity
      //   } else {
      //     this.max_kilo_capacity = kilo_capacity
      //   }
      //   if (Number(this.unallocated_quantity) > Number(this.max_kilo_capacity)) {
      //     this.unallocated_quantity = Number(this.max_kilo_capacity).toFixed(3)
      //   }
      //   if(Number(this.unallocated_quantity) < 0) {
      //     this.unallocated_quantity = 0
      //   }
      // },
      remainingQuantityKilo: function () {
        if (Number(this.unallocated_quantity) > Number(this.this.max_kilo_capacity)) {
          this.unallocated_quantity = Number(this.max_kilo_capacity).toFixed(3)
        }
      },
      totalQuantityToManufacture: {
        handler(newValue, oldValue) {
          if (Number(newValue) > Number(this.selected.max_products_possible)) {
            this.$vs.dialog({
              color: 'danger',
              title: `Warning`,
              text: `The total quantity of selected items (${newValue} Kg) exceeds the max product possible quantity (${this.selected.max_products_possible} Kg)!`,
              acceptText: 'Close'
            })
          }
        },
        deep: true
      },
      page(){
        this.loadFormulations()
      },
      perPage() {
        this.loadFormulations()
      }
    }
  }
</script>

<style scoped>

</style>
